/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Notify_RecipientInputs */

const cs_automation_notify_recipient = /** @type {(inputs: Automation_Notify_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příjemce`)
};

const en_automation_notify_recipient = /** @type {(inputs: Automation_Notify_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipient`)
};

/**
* | output |
* | --- |
* | "Recipient" |
*
* @param {Automation_Notify_RecipientInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_notify_recipient = /** @type {((inputs?: Automation_Notify_RecipientInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Notify_RecipientInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_notify_recipient(inputs)
	return cs_automation_notify_recipient(inputs)
});